/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {ANALYSIS_ROUTE_PROVIDERS as ɵa,configureRoutes as ɵb} from './providers/route.provider';